export default __webpack_public_path__ + "static/media/logout-grey.e227d47f.svg";